export default __webpack_public_path__ + "static/blog-11de5ffd937bc1ef4c3e8e7fbe858983.jpg";